// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8c352438","128":"35d034e2","189":"03d1534c","200":"ddbdf762","216":"2cfa9b0d","228":"1d94c5c5","432":"7c094f88","504":"66c73c3d","592":"8a8b7916","640":"a6620247","672":"0fc753db","752":"694a4c84","808":"010be5a9"}[chunkId] + ".chunk.js";
};